import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { compose } from 'ramda';
import { AuthStatusManager } from 'components/pages/Auth';
import ContactUs from 'components/pages/ContactUs';
import Doc from 'components/pages/Docs';
import Competitions from 'components/pages/Competitions';
import Competition from 'components/pages/Competition';
import Home from 'components/pages/Home';
import JobPage from 'components/pages/Job';
import Jobs from 'components/pages/Jobs';
import Billing from 'components/pages/Payments';
import PrivacyPolicy from 'components/pages/PrivacyPolicy';
import Settings from 'components/pages/AccountSettings';
import TermsOfUse from 'components/pages/TermsOfUse';
import { ProtectedRoute, TeamProtectedRoute } from 'components/system/ProtectedRoute';
import JobNotebook from 'components/pages/JobNotebook';
import PageNotFound from 'components/pages/PageNotFound';
import Page from 'components/pages/Layout';
import TeamPage from 'components/pages/TeamPage';
import useDocumentTitle from 'hooks/useDocumentTitle';
import CompetitionProtectedRoute from 'components/app/routes/CompetitionProtectedRoute';
import MobileCover from 'components/pages/Layout/MobileCover';
import withSignUpDialog from 'components/hoc/withSignUpDialog';
import withSignInDialog from 'components/hoc/withSignInDialog';
import BQSafeDocs from '../pages/BQSafeDocs/BQSafeDocs';
import LandingSignUp from '../pages/LandingAuth';

const AppRoutes = ({ isAppLoaded, isMobile }) => {
  useDocumentTitle();
  if (isMobile) {
    const CompetitionWithHoc = compose(withSignUpDialog, withSignInDialog)(Competition);
    return (
      <Routes>
        <Route path="/sign-up" element={<LandingSignUp view="signUp" isMobile={isMobile} />} />
        <Route path="/sign-in" element={<LandingSignUp view="signIn" isMobile={isMobile} />} />
        <Route path="/user-management" element={<AuthStatusManager isMobile={isMobile} />} />
        <Route path="/hackathons" element={<Competitions isMobile={isMobile} />} />
        <Route path="/hackathons/:id" element={<CompetitionWithHoc isMobile={isMobile} isAppLoaded={isAppLoaded} />} />
        <Route path="*" element={<MobileCover isMobile={isMobile} isAppLoaded={isAppLoaded} />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/sign-up" element={<LandingSignUp />} />
      <Route path="/" element={<Page isAppLoaded={isAppLoaded} />}>
        <Route index path="/" element={<Home />} />
        <Route element={<ProtectedRoute />}>
          <Route path="billing" element={<Billing />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="settings" element={<Settings />} />
          {process.env.TEAM_SETTINGS === 'true' && (
            <Route element={<TeamProtectedRoute redirectTo="/" />}>
              <Route path="team-settings" element={<TeamPage />} />
            </Route>
          )}
        </Route>
        <Route element={<TeamProtectedRoute strict />}>
          <Route path="hybrid-jobs-notebook/" element={<JobNotebook />} />
        </Route>
        <Route path="jobs/">
          <Route path=":id" element={<JobPage />} />
          <Route index element={<Jobs />} />
        </Route>
        <Route path="docs" element={<Doc />} />
        {process.env.COMPETITIONS === 'true' && (
          <Route element={<CompetitionProtectedRoute />}>
            <Route path="hackathons/">
              <Route path=":id" element={<Competition />} />
              <Route index element={<Competitions />} />
            </Route>
          </Route>
        )}
        <Route path="terms-of-use" element={<TermsOfUse />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="user-management" element={<AuthStatusManager />} />
        <Route path="bqsafe/about" element={<BQSafeDocs />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
